import { useEnhancedHistory } from "@/data/RouterProvider";
import { ChannelRemind } from "@/utils/UrlHelper";
import React from "react";
import style from "./style.less";

const HomeTabNav2 = ({ activeIndex, onTabChange }) => {
  const [selectedIndex, setSelectedIndex] = React.useState(activeIndex ? activeIndex : 0);
  const history = useEnhancedHistory();
  const onTabClick = (index) => {
    setSelectedIndex(index);
    if (typeof onTabChange == "function") {
      onTabChange(index);
    }
  };

  const gotoDeposit = () => {
    history.push(ChannelRemind("/home"));
  };

  return (
    <ul class={style.tab_container} style={{ marginTop: "3rem" }}>
      <li
        onClick={() => {
          onTabClick(1);
        }}
      >
        <div class={style.tab_normal} style={{ height: "1rem" }}>
          <img src={require("@/assets/images/home/class_icon/icon_GetCoins.png").default} />
          <span style={{ marginTop: "-1rem" }}>Get Coins</span>
        </div>
      </li>

      <li onClick={() => history.push(ChannelRemind("/Deposit"))}>
        <div class={style.tab_normal} style={{ height: "1rem" }}>
          <img src={require("@/assets/images/home/class_icon/icon_Deposil.png").default} />
          <span style={{ marginTop: "-1rem" }}>Deposit</span>
        </div>
      </li>

      <li onClick={() => history.push(ChannelRemind("/luckyDraw"))}>
        <div class={style.tab_normal} style={{ height: "1rem" }}>
          <img src={require("@/assets/images/home/class_icon/icon_LuckyDraw.png").default} />
          <span style={{ marginTop: "-1rem" }}>Lucky Draw</span>
        </div>
      </li>

      <li onClick={() => history.push(ChannelRemind("/invite"))}>
        <div class={style.tab_normal} style={{ height: "1rem" }}>
          <img src={require("@/assets/images/home/class_icon/icon_Promotion.png").default} />
          <span style={{ marginTop: "-0.99rem" }}>Promotion</span>
        </div>
      </li>

      <li onClick={() => history.push(ChannelRemind("/taskCenter"))}>
        <div class={style.tab_normal} style={{ height: "1rem" }}>
          <img src={require("@/assets/images/home/class_icon/icon_TaskCenter.png").default} />
          <span style={{ marginTop: "-1rem" }}>Task Center</span>
        </div>
      </li>
    </ul>
  );
};

export default HomeTabNav2;
